import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../../Utils/thunkHelpers"
import { getStatisticsAdmin } from "../../../BusinessAccountsPage/redux/businessAccounts.thunks"
import * as services from "../services"
import { REQUESTS_AUTO_REFUND_SLICE_NAME } from "./requestsAutoRefund.constants"

export const getRequestsAutoRefundFilterOptions = createAsyncThunk(
  `${REQUESTS_AUTO_REFUND_SLICE_NAME}/get_requests_auto_refund_filter_options`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsAutoRefundFilterOptions()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getRequestsAutoRefund = createAsyncThunk(
  `${REQUESTS_AUTO_REFUND_SLICE_NAME}/get_requests_auto_refund`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAutoRefundRequests(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateRequestsAutoRefund = createAsyncThunk(
  `${REQUESTS_AUTO_REFUND_SLICE_NAME}/update_requests_auto_refund`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updateAutoRefundRequests(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return response.data
  }
)

export const deleteRequestsAutoRefund = createAsyncThunk(
  `${REQUESTS_AUTO_REFUND_SLICE_NAME}/delete_requests_auto_refund`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deleteAutoRefundRequests(id)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return { id, message: response.data?.message?.detail || response.data?.message }
  }
)

export const getRequestsAutoRefundExport = createAsyncThunk(
  `${REQUESTS_AUTO_REFUND_SLICE_NAME}/get_requests_auto_refund_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsAutoRefundExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
